class HeaderSlider {
	constructor(element) {
		this.element = typeof(element) === 'string' ? document.querySelectorAll(element)[0] : element;
		this.nav = this.element.querySelector('.news-tabs');
		this.borderEle = (this.nav.previousElementSibling.classList.contains('tabs-border')) ? this.nav.previousElementSibling.children[0] : null;
		this.intervalTime = 14000;

		if(typeof this.element === 'undefined' || typeof this.element === 'undefined'){
			return false;
		}

		if(this.borderEle !== null){
			let el = this.nav.querySelectorAll('.tab')[0];
			this.borderEle.style.width = (el.offsetWidth - 20) + 'px';
			this.borderEle.style.left = (el.getBoundingClientRect().left - el.parentNode.getBoundingClientRect().left) + 'px';
		}


		this.nav.querySelectorAll('a.tab').forEach(e => e.addEventListener('click', this.change.bind(this)));
		//this.interval = setInterval(this.initInterval.bind(this), this.intervalTime);

		if(this.element.querySelector('.btn--read-more') !== null){
			this.element.querySelectorAll('.btn--read-more').forEach(el => {
				el.addEventListener('click', evt => {
					evt.preventDefault();

					if(document.querySelector('.image-text') !== null) {
						document.querySelectorAll('.image-text')[0].classList.add('open');
						$('html, body').animate({ scrollTop: ($(document.querySelectorAll('.image-text')[0]).offset().top + 50) }, 750);
					}
				});
			});
		}

		if(this.element.querySelector('.btn--testimonials') !== null){
			this.element.querySelectorAll('.btn--testimonials').forEach(el => {
				el.addEventListener('click', evt => {
					evt.preventDefault();

					if(document.querySelector('.testimonial-slider') !== null) {
						$('html, body').animate({ scrollTop: ($(document.querySelectorAll('.testimonial-slider')[0]).offset().top - 250 ) }, 750);
					}
				});
			});
		}
		if(this.element.querySelector('.btn--athletes') !== null){
			this.element.querySelectorAll('.btn--athletes').forEach(el => {
				el.addEventListener('click', evt => {
					evt.preventDefault();

					if(document.querySelector('.featured-athletes') !== null) {
						$('html, body').animate({ scrollTop: ($(document.querySelectorAll('.featured-athletes')[0]).offset().top - 100 ) }, 750);
					}
				});
			});
		}
	}

	change(e){
		if(!(e instanceof HTMLElement)){
			e.preventDefault();
			//clearInterval(this.interval);
			//this.interval = setInterval(this.initInterval.bind(this), this.intervalTime);
		}

		let el = (e instanceof HTMLElement) ? e : e.currentTarget,
			oldImage = this.element.querySelector('.tile__image'),
			newImage,
			index = [...el.parentNode.children].indexOf(el);

		this.nav.querySelectorAll('.tab').forEach(el => el.classList.remove('active'));
		el.classList.add('active');

		if(typeof el.dataset.image === 'string'){
			newImage = HeaderSlider.generateImage(el.dataset.image);
			this.element.querySelector('.tile').prepend(newImage);

			if(oldImage !== null){
				oldImage.style.opacity = 0;
				oldImage.addEventListener('transitionend', el => el.target.parentNode.removeChild(el.target));
			}
		}

		if(this.element.querySelector('.slide')) {
			this.element.querySelectorAll('.slide').forEach(el => el.classList.remove('active'));
			this.element.querySelectorAll('.slide')[index].classList.add('active');
		}

		if(this.borderEle !== null){
			this.borderEle.style.width = (el.offsetWidth - 20) + 'px';
			this.borderEle.style.left = (el.getBoundingClientRect().left - el.parentNode.getBoundingClientRect().left) + 'px';
		}

		// if(this.element.querySelector('.content') !== null){
		// 	let content = this.element.querySelector('.content');
		// 	content.querySelector('h1').textContent = el.querySelector('p').textContent;
		//
		// 	if(content.querySelector('.btn') !== null) {
		// 		console.log(el);
		// 		content.querySelector('.btn').textContent = el.getAttribute("data-buttontxt");
		// 		content.querySelector('.btn').href = el.getAttribute("data-buttonlink");
		// 		content.querySelector('.btn').style.display = 'inline-block';
		//
		// 		content.querySelector('.copy').textContent = el.getAttribute("data-copy");
		// 	}
		// }

	}

	initInterval (){
		let liEle = this.nav.querySelectorAll('a.tab.active')[0],
			index;

		index = (typeof liEle === 'undefined') ? 0 : [...liEle.parentNode.children].indexOf(liEle) + 1;

		if(typeof this.nav.querySelectorAll('a.tab')[index] === 'undefined'){
			this.change(this.nav.querySelectorAll('a.tab')[0]);
		} else {
			this.change(this.nav.querySelectorAll('a.tab')[index]);
		}
	}

	static generateImage(src){
		let image = new Image();
		image.classList.add('tile__image');
		image.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
		image.style.backgroundImage = `url(${src})`;

		return image;
	}

	static generateButton(href){
		let button = document.createElement('a');
		button.href = href;
		button.text = 'Read More';
		button.classList.add('btn', 'btn--primary');

		return button;
	}
}

export { HeaderSlider as default }
